import React, { useEffect } from "react";
import OfflineDb from "../../db";
import VendorForm from "./VendorForm";

const InventoryManagement = () => {
  useEffect(() => {
    OfflineDb.removeDataFromPouchDB("activeCaseDetails");
    OfflineDb.removeDataFromPouchDB("activeCaseFormData");
    OfflineDb.setDataIntoPouchDB("transferFlag", { type: null });
  }, []);

  return (
    <>
      <section
        className="searchcustombg searchtabmaindiv  "
        style={{ flexGrow: 1, padding: 0 }}
      >
        <div className="searchformcontainer ">
          <div className="searchtabscontainer customregistrationtabs regcasetabs ">
            <VendorForm />
          </div>
        </div>
      </section>
    </>
  );
};

export default InventoryManagement;
